import Request from './request'

const Device_Stats = {
  getDeviceStats (params, callback) {
    Request.get('device-stats/online', params).then(callback).catch(this.bad_answer)
  },
  getDeviceRSSI (params, callback) {
    Request.get('device-stats/rssi', params).then(callback).catch(this.bad_answer)
  },
  getDeviceSpeed (params, callback) {
    Request.get('device-stats/speed', params).then(callback).catch(this.bad_answer)
  },
  getDeviceTemperature (params, callback) {
    Request.get('device-stats/temperature', params).then(callback).catch(this.bad_answer)
  },
  getDeviceCPULOAD (params, callback) {
    Request.get('device-stats/cpu-load', params).then(callback).catch(this.bad_answer)
  },
  getDeviceIFace (params, callback) {
    Request.get('device-stats/iface', params).then(callback).catch(this.bad_answer)
  },

  getSimcardStatus (params, callback) {
    Request.get('device-stats/simcard-status', params).then(callback).catch(this.bad_answer)
  },
}
export default Device_Stats



